import { FC } from 'react';

export interface WeatherData {
    weatherIdx: number;
    date: string;
    dayOfWeek: string;
    weatherAm: string;
    weatherPm: string;
    rainRateAm: number;
    rainRatePm: number;
    minTemp: number;
    maxTemp: number;
    rainfall: number;
    humidity: number;
}

interface WeatherCardProps {
    weather: WeatherData;
}

const getWeatherIcon = (weatherText: string): string => {
    const iconMap: { [key: string]: string } = {
        맑음: 'clear-day.svg',
        구름많음: 'partly-cloudy-day.svg',
        구름조금: 'partly-cloudy-day.svg',
        흐림: 'overcast.svg',
        '구름많고 비': 'partly-cloudy-day-rain.svg',
        '구름많고 눈': 'partly-cloudy-day-snow.svg',
        '구름많고 비/눈': 'partly-cloudy-day-sleet.svg',
        '구름많고 소나기': 'thunderstorms-day-rain.svg',
        '흐리고 비': 'overcast-rain.svg',
        '흐리고 눈': 'overcast-snow.svg',
        '흐리고 비/눈': 'overcast-sleet.svg',
        '흐리고 소나기': 'thunderstorms-rain.svg',
        비: 'rain.svg',
        눈: 'snow.svg',
        '비/눈': 'sleet.svg',
        소나기: 'thunderstorms.svg',
    };
    return `/images/weather/svg/${iconMap[weatherText] || 'clear-day.svg'}`;
};

const WeatherCardSmall: FC<WeatherCardProps> = ({ weather }) => {
    return (
        <div className="weather-card custom-card mb-3">
            {/* 헤더 */}
            <div className="weather-card-header">
                <div className="weather-card-day">월요일</div>
                <div className="weather-card-date">05.23</div>
            </div>

            {/* 날씨 아이콘 영역 */}
            <div className="weather-card-icon-container d-flex flex-column gap-0">
                <div className="weather-am">
                    <img
                        src={getWeatherIcon(weather.weatherAm)}
                        alt={weather.weatherAm}
                        className="weather-card-icon "
                    />
                    <span>오전</span>
                </div>
                <div
                    style={{
                        width: '20px',
                        height: '1px',
                        background: '#e2e8f0',
                        margin: '-10px auto',
                        transform: 'rotate(135deg)',
                    }}
                />
                <div className="weather-pm">
                    <span>오후</span>
                    <img
                        src={getWeatherIcon(weather.weatherPm)}
                        alt={weather.weatherPm}
                        className="weather-card-icon"
                    />
                </div>
            </div>
            {/* 온도 */}
            <div className="weather-card-temp-contaner d-flex justify-content-center align-items-end">
                <div className="weather-card-temp">{weather.maxTemp}°</div>
                <div className="weather-card-temp-division">/</div>
                <div className="weather-card-temp-min ms-1">
                    <small className="text-muted">최저</small> {weather.minTemp}
                    °
                </div>
            </div>

            {/* 오전/오후 날씨 */}
            <div className="weather-card-periods">
                <div className="weather-card-period">
                    <div className="weather-card-period-label text-muted">
                        오전
                    </div>
                    <div className="weather-card-period-weather">
                        {weather.weatherAm}
                    </div>
                    <div className="weather-card-period-rain">
                        <small className="text-muted">강수</small>{' '}
                        {weather.rainRateAm}%
                    </div>
                </div>
                <div className="weather-card-period-divider" />
                <div className="weather-card-period">
                    <div className="weather-card-period-label text-muted">
                        오후
                    </div>
                    <div className="weather-card-period-weather">
                        {weather.weatherPm}
                    </div>
                    <div className="weather-card-period-rain">
                        <small className="text-muted">강수</small>{' '}
                        {weather.rainRatePm}%
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeatherCardSmall;
